var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LegendDot, StyledBorderBox, StyledText, Title, TitleSection } from './styles';
import { Text } from '../Text';
export var LegendBox = function (_a) {
  var dotColor = _a.dotColor,
    title = _a.title,
    subtitle = _a.subtitle,
    value = _a.value,
    rest = __rest(_a, ["dotColor", "title", "subtitle", "value"]);
  return _jsxs(StyledBorderBox, __assign({}, rest, {
    "data-cy-label": "legend-box",
    children: [_jsxs(TitleSection, {
      children: [_jsxs(Title, {
        children: [_jsx(LegendDot, {
          dotColor: dotColor
        }), _jsx(Text, {
          el: "span",
          styleName: "bodySmall",
          children: _jsx("strong", {
            children: title
          })
        })]
      }), subtitle && _jsx(Text, {
        el: "div",
        styleName: "bodySmall",
        children: subtitle
      })]
    }), value && _jsx(StyledText, {
      el: "div",
      styleName: "title8",
      children: value
    })]
  }));
};